import { StyledProps } from '@ui-furniture/style';

export const inputContentCss: StyledProps = {
  border: 'none',
  outline: 'none',
  background: 'transparent',
  p: 'md',
  w: '100%',
  color: {
    placeholder: 'placeholder',
  } as any,
};
